import objectHash from 'object-hash';
import { Fragment, useContext, useEffect, useRef } from 'react';

import type { ContentfulData } from '@/integrations/contentful';
import { generateSectionKey } from '@/integrations/contentful';
import { DraftModeContext } from '@/providers/DraftModeProvider/DraftModeContext';

import type { CollectionSectionOpts } from './cms';
import { renderContentfulCollectionSection } from './cms';

export const usePreRenderCmsSections = (
  allTheWatchesCmsData: ContentfulData[],
  pageName: string,
) => {
  const draftMode = useContext(DraftModeContext);
  const cmsContentMap = useRef(new Map());

  useEffect(() => {
    return () => {
      cmsContentMap.current.clear();
    };
  }, []);

  const sectionsOpts: CollectionSectionOpts = [
    {
      type: 'Placeholder',
      opts: {
        type: 'product listing',
      },
    },
    {
      type: 'HeroProductListing',
      opts: {
        type: 'watch collection',
        pageName: pageName,
      },
    },
  ];

  const buildCms = (data: ContentfulData, i: number) => {
    const hash = objectHash(data);
    let el = cmsContentMap.current.get(hash);

    if (el) {
      return el;
    }
    el = (
      <Fragment key={generateSectionKey(data, i)}>
        {renderContentfulCollectionSection(
          data,
          sectionsOpts,
          undefined,
          draftMode,
        )}
      </Fragment>
    );
    cmsContentMap.current.set(hash, el);
    return el;
  };

  const cmsSectionAll = allTheWatchesCmsData.map(buildCms);

  return { cmsSectionAll };
};
